export const validateTemplateForm = (values) => {
  let errors = {};

  if (!values.templateName?.trim()) {
    errors.templateName = "Template name is required";
  }

  if (!values.selectedTemplateCategory) {
    errors.selectedTemplateCategory = "Template category is required!";
  }

  if (values.isCustomEditor && !values.templateBody?.trim()) {
    errors.templateBody = "Template body is required";
  }

  if (values.isHtmlPaste && !values.htmlContent?.trim()) {
    errors.htmlContent = "HTML content is required";
  }

  return errors;
};

export const validateVariableForm = (values) => {
  const errors = {};

  if (!values.variableName.trim()) {
    errors.variableName = "Variable name is required!";
  }

  if (!values.selectedVariableType?.value) {
    errors.selectedVariableType = "Variable type is required!";
  }

  if (!values.selectedVariableValue) {
    errors.selectedVariableValue = "Variable value is required!";
  }

  return errors;
};

export const validateSendyListForm = (values) => {
  const errors = {};

  if (!values.listName.trim()) {
    errors.listName = "List name is required!";
  }

  if (
    values.selectedGyms?.length === 0 &&
    values.selectedMembers?.length === 0 &&
    !values.selectedSubscriptionType?.value &&
    !values.selectedPlanDuration?.value &&
    !values.startDate &&
    !values.endDate
  ) {
    errors.selectedGyms = "Gyms are required!";
    errors.selectedSubscriptionType = "Subscription type is required!";
    errors.selectedPlanDuration = "Plan duration is required!";
    errors.selectedMembers = "Members are required!";
    errors.startDate = "Start date is required!";
    errors.endDate = "End date is required!";
  }

  return errors;
};

export const validateBroadcastForm = (values) => {
  const errors = {};

  if (!values.selectedRecipient) {
    errors.selectedRecipient = "Recipient is required!";
  }

  if (
    !values.isAllMembers &&
    ((values.selectedRecipient?.value === "member" &&
      !values.selectedMembers?.length) ||
      (values.selectedRecipient?.value === "trainer" &&
        !values.selectedTrainers?.length) ||
      (values.selectedRecipient?.value === "receptionist" &&
        !values.selectedReceptionists?.length) ||
      (values.selectedRecipient?.value === "cluster_manager" &&
        !values.selectedClusterManagers?.length))
  ) {
    errors.selectedMembers = "Members are required!";
    errors.selectedTrainers = "Trainers are required!";
    errors.selectedReceptionists = "Receptionists are required!";
    errors.selectedClusterManagers = "Cluster Managers are required!";
    errors.isAllMembers = "At least one recipient is required!";
  }

  return errors;
};

export const validateReBroadcastForm = (
  values,
  emailVariableKeys = [],
  pushVariableKeys = [],
  whatsappVariableKeys = []
) => {
  const errors = {};

  if (!values.isEmail && !values.isWhatsaap && !values.isPush) {
    errors.isEmail = "At least one broadcast type is required!";
    errors.isWhatsaap = "At least one broadcast type is required!";
    errors.isPush = "At least one broadcast type is required!";
  }

  if (values.isEmail && !values.selectedEmailTemplate) {
    errors.selectedEmailTemplate = "Email template is required!";
  }

  if (values.isWhatsaap && !values.selectedWPTemplate) {
    errors.selectedWPTemplate = "Whatsapp template is required!";
  }

  if (values.isPush && !values.pushTitle) {
    errors.pushTitle = "Push title is required!";
  }

  if (values.isPush && !values.pushBody) {
    errors.pushBody = "Push body is required!";
  }

  if (values.isEmail) {
    if (
      !values.selectedEmailTemplateVariables ||
      emailVariableKeys.some(
        (key) => !values.selectedEmailTemplateVariables[key]
      )
    ) {
      errors.selectedEmailTemplateVariables =
        "Please select a variable for every key in the email template!";
    }
  }

  if (values.isPush) {
    if (
      !values.selectedPushTemplateVariables ||
      pushVariableKeys.some((key) => !values.selectedPushTemplateVariables[key])
    ) {
      errors.selectedPushTemplateVariables =
        "Please select a variable for every key in the push template!";
    }
  }

  if (values.isWhatsaap) {
    if (
      !values.selectedWPTemplateVariables ||
      whatsappVariableKeys.some(
        (key) => !values.selectedWPTemplateVariables[key]
      )
    ) {
      errors.selectedWPTemplateVariables =
        "Please select a variable for every key in the WhatsApp template!";
    }
  }

  return errors;
};

export function extractVariableKeys(templateBody) {
  const matches = templateBody?.match(/{{(\d+)}}/g) || [];
  return [...new Set(matches.map((m) => m.replace(/[{}]/g, "")))];
}

export const validateCommonBroadForm = (
  values,
  emailVariableKeys = [],
  pushVariableKeys = [],
  whatsappVariableKeys = []
) => {
  const errors = {};

  if (!values.broadcastName.trim()) {
    errors.broadcastName = "Broadcast name is required!";
  }

  if (!values.isEmail && !values.isWhatsaap && !values.isPush) {
    errors.isEmail = "At least one broadcast type is required!";
    errors.isWhatsaap = "At least one broadcast type is required!";
    errors.isPush = "At least one broadcast type is required!";
  }

  // if (values.isEmail && !values.selectedEmailTemplate) {
  //   errors.selectedEmailTemplate = "Email template is required!";
  // }

  if (values.isWhatsaap && !values.selectedWPTemplate) {
    errors.selectedWPTemplate = "Whatsapp template is required!";
  }

  if (values.isWhatsaap && !values.selectedWhatsappAccount) {
    errors.selectedWhatsappAccount = "WhatsApp account is required!";
  }

  if (values.isPush && !values.pushTitle) {
    errors.pushTitle = "Push title is required!";
  }

  if (values.isPush && !values.pushBody) {
    errors.pushBody = "Push body is required!";
  }

  // if (values.isEmail) {
  //   if (
  //     !values.selectedEmailTemplateVariables ||
  //     emailVariableKeys.some(
  //       (key) => !values.selectedEmailTemplateVariables[key]
  //     )
  //   ) {
  //     errors.selectedEmailTemplateVariables =
  //       "Please select a variable for every key in the email template!";
  //   }
  // }

  if (values.isPush) {
    if (
      !values.selectedPushTemplateVariables ||
      pushVariableKeys.some((key) => !values.selectedPushTemplateVariables[key])
    ) {
      errors.selectedPushTemplateVariables =
        "Please select a variable for every key in the push template!";
    }
  }

  if (values.isWhatsaap) {
    if (
      !values.selectedWPTemplateVariables ||
      whatsappVariableKeys.some(
        (key) => !values.selectedWPTemplateVariables[key]
      )
    ) {
      errors.selectedWPTemplateVariables =
        "Please select a variable for every key in the WhatsApp template!";
    }
  }

  return errors;
};

export const validateCampaignForm = (values) => {
  const errors = {};

  if (!values.selectedMembers?.length) {
    errors.selectedMembers = "Members are required!";
  }

  return errors;
};

export function getLabelFrom(from) {
  if (from === "wati") {
    return "Wati";
  } else if (from === "recurring") {
    return "Recurring 999";
  } else if (from === "lms") {
    return "LMS";
  } else if (from === "unpaid_members") {
    return "Unpaid Members";
  } else return from?.replace(/_/g, " ");
}

export const validateCentralisedCampaignForm = (values) => {
  const errors = {};

  if (!values.selectedPageName?.value) {
    errors.selectedPageName = "Page name is required!";
  }

  if (!values.selectedMembers?.length) {
    errors.selectedMembers = "Members are required!";
  }

  return errors;
};

export const isChannelIncluded = (channels, medium) => {
  if (channels?.toLowerCase()?.includes(medium?.toLowerCase())) {
    return true;
  }
  return false;
};

export const validateBCASchedulerForm = (values) => {
  let errors = {};

  if (!values.schedulerName?.trim()) {
    errors.schedulerName = "Scheduler name is required";
  }

  if (!values.selectedScheduleType?.value) {
    errors.selectedScheduleType = "Schedule type is required";
  }

  if (!values.selectedCondition) {
    errors.selectedCondition = "Condition is required";
  }

  if (values.selectedCondition?.value === "upcoming") {
    if (
      values.beforeDays === undefined ||
      values.beforeDays === "" ||
      isNaN(values.beforeDays)
    ) {
      errors.beforeDays = "Before days is required";
    }
  } else {
    if (
      values.afterDays === undefined ||
      values.afterDays === "" ||
      isNaN(values.afterDays)
    ) {
      errors.afterDays = "After days is required";
    }
  }

  if (!values.description?.trim()) {
    errors.description = "Description is required";
  }

  if (!values.selectedWhatsappAccount?.value) {
    errors.selectedWhatsappAccount = "Wati account is required";
  }

  if (
    !values.waTemplates ||
    !Array.isArray(values.waTemplates) ||
    values.waTemplates.length === 0
  ) {
    errors.waTemplates = "At least one WhatsApp template is required";
  } else {
    const waTemplatesErrors = values.waTemplates
      .map((template) => {
        let templateError = {};
        if (!template.selectedWPTemplate) {
          templateError.selectedWPTemplate = "Template is required";
        }
        if (
          template.selectedWPTemplate &&
          template.selectedWPTemplate.info &&
          template.selectedWPTemplate.info.body
        ) {
          const body = template.selectedWPTemplate.info.body;
          const keys = (body.match(/{{(\d+)}}/g) || []).map((m) =>
            m.replace(/[^\d]/g, "")
          );
          if (keys.length > 0) {
            templateError.variables = {};
            keys.forEach((key) => {
              if (!template.variables || !template.variables[key]) {
                templateError.variables[
                  key
                ] = `Variable for key ${key} is required`;
              }
            });
            if (Object.keys(templateError.variables).length === 0) {
              delete templateError.variables;
            }
          }
        }
        return Object.keys(templateError).length > 0
          ? templateError
          : undefined;
      })
      .filter(Boolean);

    if (waTemplatesErrors.length > 0) {
      errors.waTemplates = waTemplatesErrors;
    }
  }

  return errors;
};
